<template>
    <div>
        <template v-for="item in items">
            <slot :item="item" :is-current="isCurrent(item)" :select="select">
                {{ item.body }}
            </slot>
        </template>
        <infinite-loading @infinite="performLoading" spinner="waveDots" :distance="600" :identifier="infiniteLoadKey">
            <span slot="no-more"></span>
            <template slot="no-results">
                <h5><span class="badge badge-secondary">No results</span></h5>
            </template>
            <template v-slot:error="{ trigger }">
                <h5><span class="badge badge-danger">Whoops. It looks like the server is unavailable.</span>
                </h5>
                <div class="text-center">
                    <el-button size="mini" @click="trigger()">Retry</el-button>
                </div>
            </template>
        </infinite-loading>
    </div>
</template>

<script>
  export default {
    props: {
      url: null,
    },

    data() {
      return {
        items: [],
        cancelToken: null,
        isRequestActive: false,
        current: null,
        page: 1,
        infiniteLoadKey: moment().format('x'),
      };
    },

    computed: {
      //
    },

    watch: {
      items(value) {
        this.current = _.find(value, {id: _.get(this.current, 'id')}, null);
      },

      url(value) {
        this.refresh();
      },

      current(value) {
        this.$emit('change', value);
      },

      isRequestActive(value) {
        if (value) {
          this.$emit('refresh-start');
        } else {
          this.$emit('refresh-finish');
        }
      },
    },

    methods: {
      /**
       * @param {Object|null} $state
       * @return {undefined}
       */
      performLoading($state = null) {
        if (this.isRequestActive) {
          this.cancelToken.cancel();
        } else {
          this.isRequestActive = true;
        }

        this.cancelToken = axios.CancelToken.source();

        axios.get(this.url, {
          cancelToken: this.cancelToken.token,
          params: {page: this.page}
        })
          .then(data => this.onLoadSuccess(data, $state))
          .catch(error => this.onLoadError(error, $state))
          .then((isCancelled) => {
            if (!isCancelled) {
              this.isRequestActive = false;
            }
          });
      },

      /**
       * @param {Object} data
       * @param {Object} $state
       * @return {Boolean}
       */
      onLoadSuccess({data: {data: items, meta: {current_page, last_page}}}, $state) {
        if (_.size(items)) {
          this.items.push(...items);
          $state && $state.loaded();
        }

        if (current_page < last_page) {
          this.page++;
        } else {
          $state && $state.complete();
        }

        return false;
      },

      /**
       * @param {Object} error
       * @param {Object} $state
       * @return {Boolean}
       */
      onLoadError(error, $state) {
        if (axios.isCancel(error)) {
          return true;
        }
        $state && $state.error();

        return false;
      },

      /**
       * @return {undefined}
       */
      refresh() {
        this.items = [];
        this.page = 1;
        this.infiniteLoadKey = moment().format('x');
      },

      /**
       * @param {Object} item
       * @return {Boolean}
       */
      isCurrent(item) {
        return item === this.current;
      },

      /**
       * @param {Object} item
       */
      select(item) {
        this.current = item;
      }
    },
  }
</script>

